import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const FormInput = forwardRef(
  (
    {
      label,
      icon,
      restrictPast,
      placeholder = "",
      value = "",
      onChange = () => {},
      name = "",
      type = "text",
      disabled = false,
      error = "",
      required = false,
      className = "",
      inputClassName = "",
      labelClassName = "",
      groupClassName = "",
    },
    ref
  ) => {
    return (
      <div className={clsx("form-group mb-3", groupClassName)}>
        {label && (
          <label className={clsx("form-label text-muted", labelClassName)}>
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        <div className={clsx("input-group", className)}>
          {icon && (
            <span className="input-group-text">
              <i className={icon}></i>
            </span>
          )}

          {type === "textarea" ? (
            <textarea
              ref={ref}
              className={clsx("form-control", inputClassName, {
                "is-invalid": error,
                "is-valid": !error && value,
              })}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              disabled={disabled}
            />
          ) : (
            <input
              ref={ref}
              type={type}
              className={clsx("form-control", inputClassName, {
                "is-invalid": error,
                "is-valid": !error && value,
              })}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              disabled={disabled}
              min={
                (type === "date" || type === "datetime-local") && restrictPast
                  ? type === "datetime-local"
                    ? new Date().toISOString().slice(0, 16) // "YYYY-MM-DDTHH:MM"
                    : new Date().toISOString().split("T")[0] // "YYYY-MM-DD"
                  : undefined
              }
            />
          )}
        </div>

        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  }
);

FormInput.displayName = "FormInput"; // Required for forwardRef

FormInput.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  groupClassName: PropTypes.string,
};

export default FormInput;
